import { FeatureFlag } from "@bankmonitor/bm-ui-kit";
import "@style/overlay.scss";
import "bootstrap";

async function init() {
	await FeatureFlag.init(`${BM_API_URL}/api/public/config/feature/flags`);
	const controller = document.body.getAttribute("data-controller");

	if (controller) {
		import(
			/* webpackChunkName: "print" */
			/* webpackInclude: /print[\\/]([^\\/]+)Print\.tsx$/ */
			/* webpackExclude: /^Abstract/ */
			`./print/${controller}`
		)
			.then((module) => {
				const _tmp = new module[controller]();
			})
			.catch((reason) => console.error(reason));
	} else {
		const version = document.body.getAttribute("data-version");

		if (version) {
			import(
				/* webpackChunkName: "version" */
				/* webpackInclude: /app[\\/]([^\\/]+)\.tsx?$/ */
				`./app/${version}`
			).catch((reason) => console.error(reason));
		}
	}
}
init();
